// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DiagramChart_wrapper__1IsMP"};